import classNames from "classnames/bind";
import styles from './ServicePack.module.css';
import PropTypes from 'prop-types';
import Button from "../../../../../components/Button/Button";
import { Link } from "react-router-dom";

const cx = classNames.bind(styles)

function ServicesPack({ name, price, event, custom, code, status, image, space }) {

    const handleClickSubscribe = () => {

    }
    return (
        <div className={cx('wrapper')}>
            <div className={cx('image-desc')}>
                <img className={cx('image')} alt="normal" src={image} />
            </div>
            <p className={cx('name-pack')}>{name}</p>
            <p className={cx('price-pack')}>{price}.000đ / tháng</p>
            <ul className={cx('info-pack')}>
                <li className={cx('info-item')}>
                    <p className={cx('info-label')}>Tên dịch vụ</p>
                    <p className={cx('info-result')}>{event}</p>
                </li>
                {space && (
                    <li className={cx('info-item')}>
                        <p className={cx('info-label')}>Dung lượng lưu trữ</p>
                        <p className={cx('info-result')}>{space}</p>
                    </li>
                )}
                <li className={cx('info-item')}>
                    <p className={cx('info-label')}>Trạng thái</p>
                    <p className={cx('info-result')}>{status}</p>
                </li>
                <li className={cx('info-item')}>
                    <p className={cx('info-label')}>Cho phép cấu hình</p>
                    <p className={cx('info-result', { warning: !custom })}>{custom ? 'Có' : 'Không'}</p>
                </li>
            </ul>
            {code &&
                <Link className={cx('button')} to={`/admin/service/${code}`}>
                    <Button onClick={handleClickSubscribe} title={'Đăng ký'} className={cx('sub-button')} />
                </Link>}
        </div>
    )
}

ServicesPack.propTypes = {
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    event: PropTypes.string.isRequired,
    custom: PropTypes.bool,
    propose: PropTypes.bool,
    code: PropTypes.string
}

export default ServicesPack;